"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Search, MapPin, TrendingUp } from "lucide-react";
export default function DigitalVisibilityServices() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const services = [{
    id: 1,
    icon: Search,
    title: "SEO Audits",
    description: "Comprehensive website analysis to identify optimization opportunities and boost your search rankings."
  }, {
    id: 2,
    icon: MapPin,
    title: "Google Business Profile Optimization",
    description: "Maximize your local visibility with expertly managed Google Business listings that drive foot traffic."
  }, {
    id: 3,
    icon: TrendingUp,
    title: "Lead Generation",
    description: "Strategic digital campaigns designed to attract high-quality prospects and convert them into clients."
  }];
  return <section ref={containerRef} className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-6 md:px-8">
        <div className="mb-12 text-center">
          <h2 className="text-3xl font-bold text-foreground md:text-4xl">
            Digital Visibility Services
          </h2>
          <p className="mt-4 text-muted-foreground max-w-2xl mx-auto">
            Elevate your online presence with our cutting-edge digital marketing solutions tailored for the Nigerian market.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          const delay = i * 100;
          return <Card key={service.id} data-index={i} className={`group bg-muted border border-border rounded-lg shadow-soft transition-all duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1 hover:shadow-medium hover:border-secondary/40 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: isVisible ? `${delay}ms` : "0ms"
          }}>
                <CardHeader>
                  <div className={`inline-flex items-center justify-center w-14 h-14 rounded-md bg-primary-light mb-4 transition-all duration-300 ${isVisible ? "animate-pulse-once" : ""}`} style={{
                animationDelay: isVisible ? `${delay + 250}ms` : "0ms"
              }}>
                    <Icon className="w-7 h-7 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground group-hover:text-secondary transition-colors duration-250">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse-once {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }

        .animate-pulse-once {
          animation: pulse-once 0.6s ease-in-out 1;
        }
      `}</style>
    </section>;
}